import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-adddinetype',
  templateUrl: './adddinetype.component.html',
  styleUrls: ['./adddinetype.component.css']
})
export class AdddinetypeComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  dinetypeColl: any = [];
  dinetypeid: number = 0

  dinetypelistColl: any = [];
  pricetypeColl: any = [];

  dinetypeform = new FormGroup({
    dinetypeid: new FormControl(0),
    dinetypename: new FormControl('', Validators.required),
    dinetypelist: new FormControl('', Validators.required),
    pricetypeid: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Dinetype";


  @Input() dinetypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.dinetypeid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.dinetypeform.reset();
      this.fnInitializeDinetype();

      if (this.dinetypeid > 0) {
        this.fngetDinetype();
      
      }
      this.fngetPricetype()
      this.fngetDinetypeList();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.dinetypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeDinetype() {
    this.dinetypeform.setValue({

      dinetypeid: 0,
      dinetypename: '',
      dinetypelist: '',
      pricetypeid: null,
      inactive: false,
    })
  }
  fngetDinetypeList() {

    this.dinetypelistColl = [];
    this.dinetypelistColl.push({ value: 'DINEIN', displayname: 'Dine In' });
    this.dinetypelistColl.push({ value: 'TAKEAWAY', displayname: 'Take Away' });
    this.dinetypelistColl.push({ value: 'DELIVERY', displayname: 'Delivery' });
    //console.log(this.dinetypelistColl)
  }
  fngetPricetype() {

    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          this.pricetypeColl = res.json().result;
       
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetDinetype() {

    var data = {
      'dinetypeid': this.dinetypeid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDinetype(data)
      .subscribe(
        (res) => {
          this.dinetypeColl = res.json().result;
          var editdata = this.dinetypeColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if(this.saveloading){
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.dinetypeform.valid) {
        this.saveloading=true;
        //Check
        var data = {
          'dinetypeid': this.dinetypeid,
          'dinetypename': this.dinetypeform.get('dinetypename').value,
          'dinetypelist': this.dinetypeform.get('dinetypelist').value,
          'pricetypeid': this.dinetypeform.get('pricetypeid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.dinetypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckDinetype(data).subscribe(
          (res) => {

            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.dinetypeform.get('dinetypeid').value > 0) {
                //Update dinetype
                this.fnSetDinetype(data);
              }
              else {
                //Insert dinetype
                this.fnInsertDinetype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false;

                this.dinetypeform.controls['dinetypename'].setErrors({ 'notfound': true });
              }
              else if(_checkresult === "list") {
                this.saveloading=false;

                this.dinetypeform.controls['dinetypelist'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertDinetype(data) {

    this.appService.fnInsertDinetype(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The new Dine Type has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.dinetypeid);

          this.emitData.emit(this.dinetypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetDinetype(data) {

    this.appService.fnSetDinetype(data).subscribe(
      (res) => {
        this.saveloading=false;

        if (res.json().result != "") {
          this.toastr.success('', "The dinetype has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.dinetypeid, data.dinetypename);

          this.emitData.emit(this.dinetypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false;

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.dinetypeform.setValue({

      dinetypeid: deptBO.dinetypeid,
      dinetypename: deptBO.dinetypename,
      dinetypelist: deptBO.dinetypelist,
      pricetypeid: deptBO.pricetypeid,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
